import React, { useEffect, useState } from "react";
import { fetchModule } from "../../OnBoarding-V2/utils/fetchModule";
import GeoLocate from "../GeoLocate";
import pubsub from "@viewlift/pubsub";
import "./style.scss";

const DetailGeoLocation = (props) => {
  const [moduleData, setModuleData] = useState();
  const [showModule, setShowModule] = useState(false);

  const getModuleData = async () => {
    let { moduleData } = await fetchModule("LocateModule");
    setModuleData(moduleData);
  };

  const updateHBA = (data) => {
    setShowModule(data);
  };

  useEffect(() => {
    getModuleData();
    pubsub.subscribe("showHbaFlow", updateHBA);
  }, [showModule]);
  return (
    <>
      {showModule && (
        <div className="geoLocation-overlay">
          <div className="overlay__backdrop" onClick={() => pubsub.publish("showHbaFlow", false)}></div>
          <div className="overlay__content">
            <GeoLocate module={moduleData} NoPlans={true}/>
          </div>
          
        </div>
      )}
    </>
  );
};

export default DetailGeoLocation;
